"use client";
import { useEffect } from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

import { useStore, observer } from "../../service/mobx";

const Menu = dynamic(() => import("@mui/material/Menu"));

function MenuComponent() {
  const { bottomSheet, device, menu, user } = useStore();
  const pathname = usePathname();

  useEffect(() => {
    if (menu.open && device.isPhone) {
      bottomSheet.set.sx({ px: 0, pb: 0, overflowY: "hidden" });
      bottomSheet.configure(menu.Component);
      bottomSheet.set.onClose(() => {
        menu.onClose();
        bottomSheet.reset();
      });
    }
  }, [bottomSheet, menu, menu.open, device.isPhone]);

  // when changing pages, reset menu
  useEffect(() => {
    menu.set.open(false);
  }, [menu, pathname, device.isPhone, user.loaded]);

  return device.measured === false || device.isPhone ? null : (
    <Menu
      // This is required because in production there is a race condition with the useEffect() used
      // to close the menu on page navigation. It doesn't fire in time and the consequence is the modal
      // div sits in the DOM and does not get cleaned up because it's not part of the routes' DOM tree
      // And the page has already navigated.
      // This forces the menu to be in the DOM tree.
      disablePortal
      anchorEl={
        menu.anchorId ? document.getElementById(menu.anchorId) : menu.anchor
      }
      open={menu.open}
      onClose={() => menu.set.open(false)}
      slotProps={{
        transition: { onExit: menu.onClose },
        paper: { sx: { ...paperSx, ...menu.sx.paper } },
        list: { sx: { minWidth: 112, maxWidth: 280, ...menu.sx.menuList } }
      }}
      {...menu.options}
    >
      <menu.Component state={menu.state} />
    </Menu>
  );
}

export default observer(MenuComponent);

export const paperSx = {
  maxHeight: "50vh",
  bgcolor: "var(--surface-container-color)",
  boxShadow: "var(--elevation-2)",
  borderRadius: "var(--shape-xs-round)"
};
